import {
  Form,
  FormItem,
  Select,
  Option,
  Button,
  Input,
  MessageBox,
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'
import { mapState } from 'vuex'
import FormAdvancedField from './FormAdvancedField'
import { ROUTE_RESULT, ROUTE_SEARCH } from '@/router'
import { GET_COUNTRIES, GET_EXHIBITION_GROUP_TYPE, GET_EXHIBITION_GROUPS } from '@/store/glossary/actions'
import optionsEN from '../../lang/en_GB/options'
import optionsFR from '../../lang/fr_FR/options'
import formsEN from '../../lang/en_GB/forms'
import formsFR from '../../lang/fr_FR/forms'

export default {
  name: 'form-advanced',
  data () {
    this.$store.dispatch('glossary/' + GET_EXHIBITION_GROUP_TYPE)
    const options = this.$lang === 'fr_FR' ? optionsFR : optionsEN

    const defaultOptions = {
      type: 'exhibition',
      collection: 'all',
      exhibition: [
        { criteria: this.$t('options.exhibition')[0], strategy: options[this.$t('options.exhibition')[0].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', exhib_group: '' }
//        { criteria: this.$t('options.exhibition')[1], strategy: options[this.$t('options.exhibition')[1].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '' },
//        { criteria: this.$t('options.exhibition')[5], strategy: options[this.$t('options.exhibition')[5].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '' }
      ],
      exhibitor: [
        { criteria: this.$t('options.exhibitor')[0], strategy: options[this.$t('options.exhibitor')[0].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', gender: 'm', exhib_group: '' }
//        { criteria: this.$t('options.exhibitor')[2], strategy: options[this.$t('options.exhibitor')[2].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', gender: 'm' },
//        { criteria: this.$t('options.exhibitor')[3], strategy: options[this.$t('options.exhibitor')[3].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', gender: 'm' },
//        { criteria: this.$t('options.exhibitor')[4], strategy: options[this.$t('options.exhibitor')[4].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', gender: 'm' }
      ],
      exhibited_work: [
        { criteria: this.$t('options.exhibited_work')[0], strategy: options[this.$t('options.exhibited_work')[0].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', exhib_group: '' }
//        { criteria: this.$t('options.exhibited_work')[1], strategy: options[this.$t('options.exhibited_work')[1].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '' },
//        { criteria: this.$t('options.exhibited_work')[2], strategy: options[this.$t('options.exhibited_work')[2].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '' }
      ]
    }
    return {
      defaultOptions: defaultOptions,
      advancedSearch: defaultOptions,
      options: options,
      optionsTypes: Object.keys(optionsEN)
    }
  },
  computed: {
    ...mapState({
      glossary: state => state.glossary,
      lang: state => state.glossary.language,
      query: state => state.route.query
    }),
    countriesOptions () {
      return [{
        id: 'all',
        namefr: this.$t('forms.advanced.selectCountriesFirstOption')
      }].concat(this.glossary.countries)
    },
    exhib_groupsOptions () {
      return [{
        id: 'all',
        titlefr: this.$t('forms.advanced.selectExhib_groupsFirstOption')
      }].concat(this.glossary.exhib_groups)
    },
    exhibitionTypesOptions () {
      return [{
        id: 'all',
        typefr: formsFR.simple.data.allCollections,
        typeen: formsEN.simple.data.allCollections
      }].concat(this.glossary.exhibitionGroups)
    },
    exhibitionTypesOptionsTranslated () {
      return this.exhibitionTypesOptions.map(item => ({
        label: this.$i18n.locale === 'en_GB' ? item.typeen : item.typefr,
        value: item.id,
        id: item.id
      })).sort((a, b) => (a.id === 'all' ? -1 : (a.label > b.label ? 1 : (a.label < b.label ? -1 : 0))))
    }
  },
  methods: {
    getFilters () {
      let type = this.advancedSearch.type
      let grp = this.advancedSearch.collection
      let criterias = this.advancedSearch[type]
      let ret = [ ]
      if (grp !== 'all') {
        ret = [ ['id_exhibition_group_type', 'eq', grp.toString()] ]
      }
      ret = ret.concat(criterias.map(
        (currentCriteria, index) => {
          let property = currentCriteria.criteria.value
          let matchType = currentCriteria.strategy
          let value

          switch (currentCriteria.criteria.type) {
            case 'date':
            case 'number':
              switch (matchType) {
                case 'bt':
                  value = currentCriteria.begin + ',' + currentCriteria.end
                  break
                default:
                  value = currentCriteria.begin
                  break
              }
              break
            case 'boolean':
              matchType = 'eq'
              value = 't'
              break
            case 'gender':
              matchType = 'eq'
              value = currentCriteria.gender
              break
            case 'country':
              matchType = 'eq'
              value = currentCriteria.country
              break
            case 'exhib_group':
              matchType = 'eq'
              value = currentCriteria.exhib_group
              break
            default:
              if (matchType === 'nis') {
                value = 'null'
              } else value = currentCriteria.value.filter((item) => item !== '').join('||')
              break
          }

          return [ property, matchType, value ]
        }
      ))
      return ret
    },
    changeForm () {
      this.$router.push({
        name: ROUTE_SEARCH,
        query: {
          filters: JSON.stringify(this.getFilters()),
          type: this.advancedSearch.type,
          page: 1
        }
      })
    },
    changeCriteria (e, i) {
      this.$set(this.advancedSearch[this.advancedSearch.type][i], 'strategy', this.options[e.type + 'Strategy'][0].value)
    },
    clearForm () {
      MessageBox.confirm(this.$t('forms.advanced.resetPopup.message'), this.$t('forms.advanced.resetPopup.title'), {
        confirmButtonText: this.$t('forms.advanced.resetPopup.ok'),
        cancelButtonText: this.$t('forms.advanced.resetPopup.cancel'),
        type: 'warning'
      }).then(() => {
        this.$set(this, 'advancedSearch', this.defaultOptions)
        this.$router.push({
          name: ROUTE_SEARCH
        })
        this.$nextTick(function () {
          window.location.reload()
        })
      }).catch()
    },
    addCriteria (type) {
      if (this.options[type].length > this.advancedSearch[type].length) {
        this.advancedSearch[type].push(
          { criteria: this.options[type][0], strategy: this.options[this.options[type][0].type + 'Strategy'][0].value, value: ['', ''], begin: '', end: '', country: '', exhib_group: '' }
        )
      }
    },
    removeCriteria (type, index) {
      if (this.advancedSearch[type].length - 1 !== 0) {
        this.advancedSearch[type].splice(index, 1)
      }
    },
    addTextValue (item) {
      item.value.push('')
    },
    submitForm () {
      this.$router.push({
        name: ROUTE_RESULT,
        query: {
          filters: JSON.stringify(this.getFilters()),
          type: this.advancedSearch.type,
          page: 1
        }
      })
    }
  },
  mounted () {
    this.$store.dispatch('glossary/' + GET_COUNTRIES)
    this.$store.dispatch('glossary/' + GET_EXHIBITION_GROUPS)

    let collection = 'all'
    if (this.query.type) {
      this.$set(this.advancedSearch, 'type', this.query.type)
      if (this.query.filters) {
        const filters = JSON.parse(this.query.filters)
        const type = this.query.type
        let value = ''
        let strategy = this.options[this.options[type][0].type + 'Strategy'][0].value
        let begin = ''
        let end = ''
        let country = ''
        let exhib_group = ''
        let gender = ''
        let ind
        for (ind = 0; ind < filters.length; ++ind) {
          if (filters[ind][0] === 'id_exhibition_group_type') {
            collection = filters[ind][2]
            break
          }
        }

        let filters2 = filters.filter(filt => {
          for (ind = 0; ind < this.$t('options.' + type).length; ++ind) {
            if (filt[0] === this.$t('options.' + type)[ind].value) {
              return true
            }
          }
          return false
        })
        filters2.map((filter, i) => {
          let criteria = this.$t('options.exhibition')[0]
          strategy = filter[1]

          this.$t('options.' + type).map(opt => {
            if (opt.value === filter[0]) {
              criteria = opt
            }
            return opt
          })

          switch (criteria.type) {
            case 'date':
            case 'number':
              const dataArray = filter[2].split(',')
              begin = dataArray[0]
              end = dataArray[1]
              break
            case 'boolean':
            case 'text':
              value = filter[2].split('||')
              break
            case 'gender':
              gender = filter[2]
              value = ['', '']
              break
            case 'country':
              country = filter[2]
              value = ['', '']
              break
            case 'exhib_group':
              exhib_group = filter[2]
              value = ['', '']
              break
          }

          this.$set(this.advancedSearch[this.query.type], i, {
            criteria: criteria, strategy, value, begin, end, country, gender, exhib_group
          })
        })
      }
    }
    collection = parseInt(collection, 10)
    if (isNaN(collection)) {
      collection = 'all'
    }
    this.$set(this.advancedSearch, 'collection', collection, 10)
  },
  watch: {
    advancedSearch: function () {
      this.changeForm()
    }
  },
  components: {
    elForm: Form,
    elFormItem: FormItem,
    elSelect: Select,
    elOption: Option,
    elInput: Input,
    elButton: Button,
    FormAdvancedField,
    elBreadcrumb: Breadcrumb,
    elBreadcrumbItem: BreadcrumbItem
  }
}



// WEBPACK FOOTER //
// ./src/components/FormAdvanced/FormAdvanced.js